

<app-address-autocomplete [(address)]="address"></app-address-autocomplete>

<!-- <mat-form-field class="create-form-field create-form-address" appearance="outline" *ngFor="let field of getAddressKeys()">
		<mat-label>{{ camelToWords(field) }}</mat-label>
		<input matInput placeholder="{{field}}" type="text" name="field" [ngModel]="address[field]" (keyup.enter)="onEnter()" enabled="isEditing">
</mat-form-field> -->

